// React
import React, { FC } from 'react';

// Styles
import injectSheet from 'react-jss';

// Assets
import SadBrowserIcon from 'Assets/ui/sadBrowser.svg';
import styleSheet from './styles';

interface Props {
  classes?: any;
}

const GoodDataIncompatibleBrowserModal: FC<Props> = (props: Props) => {
  const { classes } = props;

  return (
    <div className={classes.container}>
      <div className={classes.svgContainer}>
        <SadBrowserIcon />
      </div>
      <div className={classes.titleContainer}>
        <span className={classes.title}>Oops! Something went wrong</span>
      </div>
      <div className={classes.descriptionContainer}>
        <span className={classes.description}>
          Your current web browser does not support our data dashboards.
          <br />
          <br />
          Please switch to
          <strong> Google Chrome </strong>
          for a great experience.
        </span>
      </div>
    </div>
  );
};

GoodDataIncompatibleBrowserModal.defaultProps = {
  classes: {},
};

export default injectSheet(styleSheet)(GoodDataIncompatibleBrowserModal);
